module.exports = __webpack_public_path__ + "img/cacib.01f4a030.svg";